import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import withAuthLogin from 'hoc/withAuthLogin';
import styles from 'styles/Layout.module.scss';
import Header from '../Layout/Header/Header';
import Footer from '../Layout/Footer/Footer';
import { useDispatch } from 'react-redux';
import { getColorThemeAsync } from 'store/settings';
import ManageCmsBlogApi from 'api/manageCMSBlogApi';

const LandingLayout = ({ children }) => {
  const getColorTheme = async () => {
    const response = await ManageCmsBlogApi.getEnrollStatus();
    if (response?.length) {
      let colorObj = {};
      response?.map((data) => {
        if (data?.key == 'themeColor') {
          colorObj.themeColor = data?.value;
        }
        if (data?.key == 'buttonColor') {
          colorObj.buttonColor = data?.value;
        }
        if (data?.key == 'buttonTextColor') {
          colorObj.buttonTextColor = data?.value;
        }
        if (data?.key == 'menuTextColor') {
          colorObj.menuTextColor = data?.value;
        }
      });
      localStorage.setItem('colorThemeLocal', JSON.stringify(colorObj));
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    getColorTheme();
    dispatch(getColorThemeAsync());
  }, []);

  return (
    <div className={styles.container}>
      <Header />
      <div className={classnames('mb-1', 'container', styles.content)}>
        {children}
      </div>
      <Footer />
    </div>
  );
};

LandingLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default withAuthLogin(LandingLayout);
